// entry point file - here we initialize the vue application
import { createApp } from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';
import VeeValidatePlugin from './plugins/validation';
import { auth } from './includes/firebase';
import './assets/tailwind.css';
import './assets/main.css';

let app;

auth.onAuthStateChanged(() => {
  // if it has been initialized we will not need to do it again
  if (!app) {
    app = createApp(App);
    app.use(store); // being registered as a plugin, exposes methods for working with the store

    app.use(router);
    // this plugin will expose the methods and properties interactindg with the router
    // settings are configures in another file

    app.use(VeeValidatePlugin);
    // registering plugins must be performed before mounting the instance

    app.mount('#app');
  }
});
